(function (module) {
    "use strict";

    module.service('freezedMonthsService', ['synchronousEventsBus',
        function(this: $TSFixMe, synchronousEventsBus: $TSFixMe) {
            var service = this;

            service.registerEvents = function () {
                synchronousEventsBus.$on('regressionCalculated', function (e: $TSFixMe, args: $TSFixMe) {
                    return service.recalculateFreezedMonth(args.forecast, args.parameters);
                });
            }

            service.recalculateFreezedMonth = (forecast: $TSFixMe, parameters: $TSFixMe) => {


                const freezedMonths = angular._get(forecast, 'freezedMonths', 0);

                const freezedMonthsVolume = angular._get(forecast, 'freezedMonthsVolume', []);

                forecast.freezedMonthForecast = freezedMonthsVolume.concat(forecast.statisticalForecast.slice(freezedMonths));
                return synchronousEventsBus.$broadcast('freezedMonthCalculated', { forecast, parameters });
            }

        }]);
    module.run(['freezedMonthsService', (service: $TSFixMe) => { service.registerEvents(); }]);

})(angular.module('topline.services'));